import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-document-icon',
  templateUrl: 'document-icon.component.html'
})
export class DocumentIconComponent {
  constructor() {}
}
